import styled from 'styled-components';

import {
  aspectRatio,
  breakpoints,
  colors,
  fontFamily,
  functions,
} from '../../ui/variables';

const main = {
  padding: {
    iphone: '22%',
  },
};

const glyphoLabel = {
  width: {
    iphone: `calc(50% + ${main.padding.iphone})`,
  },
};

const glyphLegendList = {
  paddingTop: {
    iphone: `calc((${main.padding.iphone} / 2) + 16px)`,
  },
};

export const GlyphChartStyle = styled.div`
  background-color: ${colors.mostlyWhite};
  border-radius: 12px;
  overflow: hidden;
  padding: ${main.padding.iphone} 0 0;
  position: relative;

  &.chart-only {
    background-color: transparent;
    border-radius: initial;
    overflow: initial;
    padding: 0;
    width: 100%;

    .glyph-content-wrapper {
      padding: 0;
      width: 100%;

      .glyph-content {
        position: relative;
        ${aspectRatio.ratio1To1};

        .circles-wrapper {
          left: 0;
          position: absolute;
          top: 0;

          .slice-outline {
            height: 1px;
            opacity: 0.8;
          }
        }

        .glypho-default-lines {
          left: 0;
          opacity: 0;
          position: absolute;
          top: 0;
          width: 100%;
        }
      }
    }
  }

  .glyph-content-wrapper {
    padding: 0 ${main.padding.iphone};

    .glyph-content {
      margin: 0 auto;
      position: relative;
      width: 100%;

      .circles-wrapper {
        ${aspectRatio.ratio1To1};
        border-radius: 50%;
        position: absolute;
        transform-origin: center center;

        .chart-slices-wrapper {
          border-radius: 50%;
          display: block;
          overflow: hidden;

          .single-slice {
            left: 50%;
            opacity: 1;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            transition: fill 300ms, stroke 300ms;

            &.slice-normal {
              fill: ${colors.softBlue};
              stroke-width: 0.015;
              stroke: ${colors.softBlue};
            }

            &.slice-high {
              fill: ${colors.softYellow};
              stroke-width: 0.015;
              stroke: ${colors.softYellow};
            }

            &.slice-low {
              fill: ${colors.softRed};
              stroke-width: 0.015;
              stroke: ${colors.softRed};
            }

            &.slice-fix {
              fill: ${colors.mostlyWhite};
              stroke-width: 0.015;
              stroke: ${colors.mostlyWhite};
            }

            &.active {
              &.slice-normal {
                fill: ${colors.softBlue};
                stroke: ${colors.softBlue};
              }

              &.slice-high {
                fill: ${colors.softYellow};
                stroke: ${colors.softYellow};
              }

              &.slice-low {
                fill: ${colors.softRed};
                stroke: ${colors.softRed};
              }
            }

            &.disabled {
              &.slice-normal {
                fill: ${functions.flattened(
                  colors.softBlue,
                  colors.white,
                  0.2
                )};
                stroke: ${functions.flattened(
                  colors.softBlue,
                  colors.white,
                  0.2
                )};
              }

              &.slice-high {
                fill: ${functions.flattened(
                  colors.softYellow,
                  colors.white,
                  0.2
                )};
                stroke: ${functions.flattened(
                  colors.softYellow,
                  colors.white,
                  0.2
                )};
              }

              &.slice-low {
                fill: ${functions.flattened(colors.softRed, colors.white, 0.1)};
                stroke: ${functions.flattened(
                  colors.softRed,
                  colors.white,
                  0.2
                )};
              }
            }
          }
        }

        .slice-outline {
          background-color: ${colors.white};
          display: block;
          height: 2px;
          left: 75%;
          position: absolute;
          top: 50%;
          transform-origin: left center;
          transform: translate(-50%, -50%);
          width: 50%;
        }
      }

      .glypho-label {
        left: 50%;
        position: absolute;
        text-align: right;
        top: 50%;
        transform-origin: left center;
        width: ${glyphoLabel.width.iphone};

        .glypho-label-text {
          ${fontFamily.sourceSansPro.bold};
          color: ${colors.veryDarkGrayishBlue};
          display: inline-block;
          font-size: 16px;
          line-height: 1;

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            font-size: 20px;
          }
        }
      }

      .glypho-default-lines {
        opacity: 0;

        &.disabled {
          svg {
            stroke: ${colors.grayishBlue};
          }
        }

        svg {
          fill: none;
          position: relative;
          stroke-miterlimit: 10;
          stroke-width: 0.5px;
          stroke: ${colors.white};

          @media (min-width: ${breakpoints.ipad.width}px) {
            stroke-width: 0.75px;
          }

          @media (min-width: ${breakpoints.hd.width}px) {
            stroke: ${colors.mostlyWhite};
            stroke-width: 1px;
          }
        }
      }
    }
  }

  .glyph-legend-list {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: ${glyphLegendList.paddingTop.iphone} 20px 20px;

    .glyph-legend-item {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.veryDarkGrayishBlue};
      display: block;
      font-size: 12px;
      line-height: 16px;
      padding-left: 24px;
      position: relative;

      &:after {
        content: '';
        height: 16px;
        left: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
      }

      &.normal {
        &:after {
          background-color: ${colors.softBlue};
        }
      }

      &.high {
        &:after {
          background-color: ${colors.softYellow};
        }
      }

      &.low {
        &:after {
          background-color: ${colors.softRed};
        }
      }
    }
  }
`;
